import { render, staticRenderFns } from "./BannedServers.vue?vue&type=template&id=38ff0806&"
import script from "./BannedServers.vue?vue&type=script&lang=js&"
export * from "./BannedServers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports